export const MICRO_SERVICE_MAPPING_KEYS = {
    msId: 'microserviceId',
    msNm: 'microserviceName',
    pId: 'permissionId',
    pNm: 'permissionName',
    pDNm: 'permissionDisplayName',
    val: 'value',
    pVls: 'permissionValues',
    nm: 'name',
    prm: 'permission',
    prms: 'permissions',
};

export const MICRO_SERVICE_MAPPING_KEYS_REVERSE = {
    microserviceId: 'msId',
    microserviceName: 'msNm',
    permissionId: 'pId',
    permissionName: 'pNm',
    permissionDisplayName: 'pDNm',
    value: 'val',
    permissionValues: 'pVls',
    name: 'nm',
    permission: 'prm',
    permissions: 'prms',
};
